import React, { Fragment } from "react";
import Header from "./Header";
import Content from "./Content";
import "../index.css";

export default function App() {
  return (
    <Fragment>
      <Header />
      <Content />
    </Fragment>
  );
}
